import { Box, Paper, Typography, List, ListItem, styled } from "@mui/material"

import Button from "components/ui/Button"

export const Card = styled(Paper)(({ theme }) => ({
  boxShadow: "12px 14px 23px -2px rgb(0 0 0 / 3%)",
  borderRadius: "26px",
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: "38px",
  marginBottom: "16px",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    margin: "0 0 12px 0",
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    padding: "16px",
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.375rem",
  },
}))

export const Description = styled(Typography)(({ theme }) => ({
  margin: "12px 0",
  [theme.breakpoints.down("lg")]: {},
}))

export const DescriptionList = styled(List)(() => ({
  listStyle: "disc",
  margin: "0 0 0 20px",
  width: "100%",
}))

export const DescriptionListItem = styled(ListItem)(() => ({
  display: "list-item",
  fontSize: "0.875rem",
  fontWeight: 500,
  margin: "0",
  padding: "3px 0",
}))

export const Actions = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  marginRight: "10px",
}))

export const Btn = styled(Button)(({ theme }) => ({
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "44px",
  padding: "0 20px",
  width: "175px",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "8px 0",
    width: "100%",
  },
}))

export const Pay = styled(Btn)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
}))
